import { FC, ReactNode } from "react";

import { Box, useTheme } from "@mui/material";

import { Footer } from "./Footer/Footer";
import { GrantFinderPageViewTracker } from "./GrantFinderPageViewTracker";
import { Navbar } from "./Navbar/Navbar";

import { AmplitudeProvider } from "@/common/providers/AmplitudeProvider";

interface GrantFinderLayoutProps {
  slots: {
    main: ReactNode;
  };
}

export const GrantFinderLayout: FC<GrantFinderLayoutProps> = ({ slots }) => {
  const theme = useTheme();

  return (
    <AmplitudeProvider>
      <GrantFinderPageViewTracker />
      <Box
        sx={{
          minHeight: "100vh",
          ["@supports (min-height: 100dvh)"]: { minHeight: "100dvh" },
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#F8F8FF",
          color: theme.palette.text.primary,
          fontFamily: theme.typography.fontFamily,
        }}
      >
        <Navbar />
        <Box component="main" sx={{ flex: 1 }}>
          {slots.main}
        </Box>
        <Footer />
      </Box>
    </AmplitudeProvider>
  );
};
